module.exports = __webpack_public_path__ + "static/media/angel-city.65a9e366.jpg";